// Material Kit 2 React pages
import News from "pages/News";

export default function NewsPage() {
  return <News />;
}
